import { ITableSetting } from "../../../../Table/BasicTable";
import { CMSTag } from "../../../../../models/CMS/cmsTag";
import {
  IconWrapper,
  ImageWrapper,
} from "../../../ui-components/pageLayout/TableSettingsComponents";
import noImage from "../../../../../../resources/missing-img.png";
import { MdModeEditOutline } from "react-icons/md";
import React from "react";

export const TagsPageTableSettings: ITableSetting<CMSTag>[] = [
  {
    id: "image-id",
    align: "left",
    name: "",
    path: "gg",
    content: (data: CMSTag) => (
      <ImageWrapper>
        <div
          className="image"
          style={{
            backgroundImage: `url(${data.getImage("sv") || noImage})`,
          }}
        />
      </ImageWrapper>
    ),
  },
  {
    id: "name-id",
    align: "left",
    name: "NAME",
    path: "NAME",
    content: (data: CMSTag) => <div>{data.getDisplayName()}</div>,
  },
  {
    id: "type",
    align: "left",
    name: "TYPE",
    path: "TYPE",
    content: (data: CMSTag) => <div>{data.type}</div>,
  },
  {
    id: "id-id",
    align: "left",
    name: "ID",
    path: "ID",
    content: (data: CMSTag) => <div>{data.getUniqueId()}</div>,
  },
  {
    id: "external-id",
    align: "left",
    name: "EXTERNALID",
    path: "EXTERNALID",
    content: (data: CMSTag) => <div>{data.externalId}</div>,
  },
  {
    id: "created-id",
    align: "left",
    name: "CREATED",
    path: "CREATED",
    content: (data: CMSTag) => <div>{data.createdAt}</div>,
  },
  {
    id: "changed-id",
    align: "left",
    name: "CHANGED",
    path: "CHANGED",
    content: (data: CMSTag) => <div>{data.updatedAt}</div>,
  },
  {
    id: "edit-id",
    align: "right",
    name: "",
    path: "gh",
    content: (data: CMSTag) => (
      <IconWrapper>
        <MdModeEditOutline />
      </IconWrapper>
    ),
  },
];
